import React from 'react';
import { useQuoteStore } from '@/hooks/use-quote';
import { useEffect } from 'react';
import { restoreScrollPosition } from '@/hooks/quote/requote-redirect';
import { QuoteState } from '@/schemas/quoteResponseSchema';

interface CoverageSceneWrapperProps {
  children: React.ReactNode;
  initial_state: QuoteState;
}

export const CoverageSceneWrapper: React.FC<CoverageSceneWrapperProps> = ({ children, initial_state }) => {
  const setQuote = useQuoteStore((state) => state.setQuote);

  setQuote(initial_state);

  useEffect(() => {
    restoreScrollPosition();
  }, []);

  return <>{children}</>;
};
